module.exports = __webpack_public_path__ + "static/logo-361fa5af188cc5e9250e6b5e9cf956c8.svg";